import { fetch } from '@utils/utils';
import * as T from '@modules/roles-create/_rolesCreateTypes';

const getRole = ({ addError }) => async (id: string): Promise<T.Role> => {
  try {
    const response: any = await fetch(`/metropolis/api/roles/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Role = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

const getRoles = async (): Promise<Array<T.Role>> => {
  try {
    const response: any = await fetch(`/metropolis/api/roles/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: Array<T.Role> = await response.json();

    return json;
  } catch (err) {
    return [];
  }
};

const getPermissions = async (): Promise<Array<T.Permission>> => {
  try {
    const response: any = await fetch(`/metropolis/api/permissions/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: Array<T.Permission> = await response.json();

    return json;
  } catch (err) {
    return [];
  }
};

const putPermissions = async data => {
  try {
    await fetch(`/metropolis/api/roles/${data.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(data)
    });

    return true;
  } catch (err) {
    return false;
  }
};

export { getRole, getRoles, getPermissions, putPermissions };



// WEBPACK FOOTER //
// ./src/modules/roles-create/_rolesCreateActions.ts